module.exports = __webpack_public_path__ + "img/img_wave.1ab1478f.png";